import React from 'react';
import { useHistory } from 'react-router-dom';
import { ArcRoutes } from '../../../pages/arc/constants/routes';
import { buttonStyles } from '../../constants/theme/styles/components/buttonstyles';
import { useBasePath } from '../../hooks/useBasePath';

interface Props {
	redirect: string,
	buttonText: string,
}
export const BillingAccountSelectButton = (props: Props) => {
	const history = useHistory();
	const butttonClasses = buttonStyles();
	const billingAccountSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.BillingAccountsSearch}`);
	const action = () => {
		history.push(billingAccountSelect,
			{
				externalAction: props.redirect,
			},
		);
	};
	return <button type='button' className={butttonClasses.secondaryButton} onClick={action}>{props.buttonText}</button>;
};
